/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { request } from 'meinian-package/src/utils'
import { FloatAction } from 'component'
import isLogin from '../common/isLogin'
import './index.less'

export default () => {
  useEffect(() => {
    document.title = '美念'
    window.scrollToTop()
    init()
  }, [])
  const init = async () => {
    await fetchFilters()
  }
  const fetchFilters = async () => {
    if (isLogin()) {
      const res = await request.get('/zhikuan/common/list-common-menu-item', { ignoreError: true })
      sessionStorage.setItem('meinianFilters', JSON.stringify(res))
    } else {
      sessionStorage.setItem('meinianFilters', JSON.stringify({}))
    }
  }

  return <div className="meinian" style={{ width: '100%' }}>
    {window.location.pathname.startsWith('/meinian/home/tag') ? null
      : <FloatAction />}
    <Outlet />
  </div>
}
